<template>
  <div>
    <div class="color-line"></div>
    <template v-if="$route.meta.code === 403">
      <error403></error403>
    </template>
    <template v-else>
      <error404></error404>
    </template>
  </div>

</template>

<style>
</style>
<script>

import Error403 from '../../components/error/Error403'
import Error404 from '../../components/error/Error404'
export default {
  components: {Error404, Error403},
  name: 'Error',
}
</script>



// WEBPACK FOOTER //
// src/pages/error/index.vue